(function () {
  var el = document.getElementById('bb-tier-migration-chart');
  if (!el) return;

  var DATA_URL = el.getAttribute('data-data-url');
  var LAYOUT_URL = el.getAttribute('data-layout-url');
  var TITLE = el.getAttribute('data-title');
  var NEW_ENTRANTS = el.getAttribute('data-new-entrants');
  var EXITS = el.getAttribute('data-exits');
  var MONTHS = (el.getAttribute('data-months') || '').split(',');
  var ZOOM_TEXT = el.getAttribute('data-zoom-text');
  var ISOLATE_TEXT = el.getAttribute('data-isolate-text');
  var THROUGH_LABEL = el.getAttribute('data-through-label');
  var LANG = (document.documentElement.lang || '').slice(0, 2).toLowerCase();

  function renderChart(data, layout) {
    if (TITLE) layout.title.text = TITLE;

    // Real, reproducible "data through" date - read from the same series
    // driving the chart, not invented (2026-08-31 third review §6.1).
    var throughEl = document.getElementById('bb-tier-migration-through');
    if (throughEl && THROUGH_LABEL && data[0] && data[0].x && data[0].x.length) {
      var lastX = data[0].x[data[0].x.length - 1];
      var lastDate = String(lastX).slice(0, 10);
      throughEl.textContent = ' ' + THROUGH_LABEL + ' ' + lastDate + '.';
    }

    // Translate series names in legend and their hover tooltip labels
    data.forEach(function (trace) {
      if (trace.name === 'New Entrants' && NEW_ENTRANTS) {
        if (trace.hovertemplate) trace.hovertemplate = trace.hovertemplate.replace('New Entrants:', NEW_ENTRANTS + ':');
        trace.name = NEW_ENTRANTS;
      }
      if (trace.name === 'Exits' && EXITS) {
        if (trace.hovertemplate) trace.hovertemplate = trace.hovertemplate.replace('Exits:', EXITS + ':');
        trace.name = EXITS;
      }
    });

    // Build quarterly x-axis ticks with translated month names
    if (MONTHS.length === 12 && data[0] && data[0].x) {
      var seen = {}, tickvals = [], ticktext = [];
      data[0].x.forEach(function (d) {
        var dt = new Date(d);
        var m = dt.getUTCMonth();
        var y = dt.getUTCFullYear();
        var key = y + '-' + m;
        if (!seen[key] && m % 3 === 0) {
          seen[key] = true;
          tickvals.push(d);
          ticktext.push(MONTHS[m] + ' ' + y);
        }
      });
      layout.xaxis.tickvals = tickvals;
      layout.xaxis.ticktext = ticktext;
    }

    // Translate Plotly's "Double-click to zoom back out" toast notification.
    // Plotly renders this via Lib.notifier() using its locale system — the key
    // is the plain English string with no <br> tags.
    if (LANG === 'et' && (ZOOM_TEXT || ISOLATE_TEXT)) {
      var dict = {};
      if (ZOOM_TEXT) dict['Double-click to zoom back out'] = ZOOM_TEXT;
      if (ISOLATE_TEXT) dict['Double-click on legend to isolate one trace'] = ISOLATE_TEXT;
      Plotly.register({ moduleType: 'locale', name: 'et', dictionary: dict });
    }

    // responsive:false — we handle all resizing ourselves to avoid Plotly
    // adding its own internal ResizeObserver on gd (which would conflict with
    // ours and cause a double-resize feedback loop during the opacity fade).
    var plotConfig = { displayModeBar: false, responsive: false };
    if (LANG === 'et') plotConfig.locale = 'et';

    Plotly.newPlot('bb-tier-migration-chart', data, layout, plotConfig).then(function (gd) {
      // Resize to the container's final CSS-settled size, then reveal.
      // Promise.resolve() handles both the case where Plotly.Plots.resize
      // returns a promise (Plotly 2.x) and where it returns undefined (older).
      // Watching gd.parentElement (not gd itself) means our resize call
      // doesn't trigger the observer again — no feedback loop.
      Promise.resolve(Plotly.Plots.resize(gd)).then(function () {
        requestAnimationFrame(function () {
          gd.style.opacity = '1';
        });
      });

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          Plotly.Plots.resize(gd);
        });
        ro.observe(gd.parentElement);
      }
    });
  }

  function loadChartData() {
    Promise.all([
      fetch(DATA_URL).then(function (r) { return r.json(); }),
      fetch(LAYOUT_URL).then(function (r) { return r.json(); })
    ]).then(function (results) {
      renderChart(results[0], results[1]);
    }).catch(function (err) {
      console.warn('BullBreak chart load error:', err);
    });
  }

  if (window.Plotly) {
    loadChartData();
  } else {
    var s = document.createElement('script');
    s.src = 'https://cdn.plot.ly/plotly-2.32.0.min.js';
    s.onload = loadChartData;
    document.head.appendChild(s);
  }
})();
